"use client"
import React, { useState, useEffect } from "react";
import { Collapse, Container, DropdownItem, DropdownMenu, DropdownToggle, NavbarToggler, NavLink, UncontrolledDropdown} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-c191254f72/icons'
import { Link } from "gatsby"

// Import Images
import logodark from "../../assets/images/logo-sm.png";

const Navbar = () => {
    const [isOpenMenu, setisOpenMenu] = useState(false);
    const [navClass, setNavClass] = useState("");

    const toggle = () => setisOpenMenu(!isOpenMenu);

    useEffect(() => {
        // Function to handle the scroll event
        const handleScroll = () => {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollPosition > 50) {
                setNavClass("is-sticky");
            } else {
                setNavClass("");
            }
        };

        // Check if window is defined (i.e., we're in the browser)
        if (typeof window !== 'undefined') {
            window.addEventListener("scroll", handleScroll, true);

            // Cleanup function to remove the event listener
            return () => window.removeEventListener("scroll", handleScroll, true);
        }
    }, []);

    return (
        <React.Fragment>
            <nav className={"navbar navbar-expand-lg navbar-landing fixed-top " + navClass} id="navbar">
                <Container>
                    <Link className="navbar-brand" to="/">
                        <img src={logodark} className="card-logo card-logo-dark" alt="logo dark" height="50" />
                    </Link>

                    <NavbarToggler className="navbar-toggler py-0 fs-20 text-body border-0" onClick={toggle} type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        {/* <span> */}
                            <FontAwesomeIcon icon={byPrefixAndName.far['bars']} />
                        {/* </span> */}
                    </NavbarToggler>

                    <Collapse
                        isOpen={isOpenMenu}
                        className="navbar-collapse"
                        id="navbarSupportedContent"
                    >
                        <div

                            className="navbar-nav mx-auto mt-2 mt-lg-0"
                            id="navbar"
                        >
                            
                            <span className="nav-link nav-item">
                                <Link className="fs-15 nav-link" to="/Tour">Product Tour</Link>
                            </span>
                            <span className="nav-link nav-item">
                                <Link className="fs-15 nav-link" to="/Pricing">Pricing</Link>
                            </span>
                            
                            
                            <span className="nav-link nav-item">
                                <a className="fs-15 nav-link" target="blank" href="https://docs.gallium.cloud">Docs</a>
                            </span>
                        </div>
                            
                        <div className="">
                            
                            <Link to="/demo" className="btn btn-primary">Try Gallium</Link>
                            <a href="https://console.gallium.cloud" className="btn btn-outline-primary fw-medium ms-3">
                                Console Login
                            </a>
                        </div>
                    </Collapse>
                </Container>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;

